import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider/stocks'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class StocksApi {

    static async saveParser({ data = { providerId: undefined, files: undefined }, ...params }) {
        return await fetchService({ url: '/addparser', method: 'POST', data, ...params })
    }

    static async addStocks({ data = { providerId: 'ProviderId', products: 'Array', skladName: undefined }, ...params }) {
        return await fetchService({ url: '/addstocks', method: 'POST', data, ...params })
    }





    static async saveNashaIgrushka({ data = { files: undefined }, ...params }) {
        return await fetchService({ url: '/savenashaigrushka', method: 'POST', data, ...params })
    }

    static async save18({ data = { files: undefined }, ...params }) {
        return await fetchService({ url: '/savesex', method: 'POST', data, ...params })
    }

    static async saveVostok({ data = { files: undefined }, ...params }) {
        return await fetchService({ url: '/savevostok', method: 'POST', data, ...params })
    }

    static async saveNatureVector({ data = { files: undefined }, ...params }) {
        return await fetchService({ url: '/savevector', method: 'POST', data, ...params })
    }

}